import type { Strings } from "./strings.en";

export const hi: Partial<Strings> = {
  nav_home: "होम",
  nav_drill: "ड्रिल आज़माएँ",
  nav_new: "तिजोरी सील करें",
  nav_checkin: "चेक-इन",
  nav_custodian: "संरक्षक",
  nav_vaults: "सभी तिजोरियाँ",
  nav_verify: "हमारे बिना जाँचें",

  hero_kicker: "RTI कार्यकर्ताओं, व्हिसलब्लोअर्स और उनके साथ खड़े लोगों के लिए",
  hero_title: "मेरी धड़कन रुकी, तो सच बाहर आएगा।",
  hero_body: "भारत के RTI आवेदकों के लिए: आज ही अपने जवाब की समय-सीमा और अपील की तारीखें जानें, और अगर काम ख़तरनाक हो जाए, तो अपने सबूत सील करें, ताकि आपको चुप कराने पर वे सामने आ जाएँ।",
  hero_cta_drill: "5 मिनट में होते हुए देखें",
  hero_cta_new: "असली तिजोरी सील करें",
  hero_note: "Arkiv के Tiramisu टेस्टनेट पर चलता है। केवल टेस्ट दस्तावेज़ इस्तेमाल करें।",

  why_title: "यह क्यों ज़रूरी है",
  why_1: "लोग 2005 से RTI के तहत जानकारी माँगने के कारण मारे गए (CHRI ट्रैकर)।",
  why_2_n: "12 साल",
  why_2: "से व्हिसल ब्लोअर्स संरक्षण अधिनियम, 2014 लागू होने का इंतज़ार कर रहा है।",
  why_3: "ऐसे टूल जो किसी कार्यकर्ता को चुप कराए जाने पर उसके निष्कर्ष अपने-आप जारी कर दें।",
  why_story: "महाराष्ट्र में RTI कार्यकर्ताओं की हत्या के बाद शोधकर्ताओं ने पाया कि कुछ परिवारों ने डर के मारे दस्तावेज़ जला दिए थे। सूचना आयोग ने एक बार आदेश दिया था कि मारे गए कार्यकर्ता ने जो भी माँगा था, वह तुरंत सार्वजनिक किया जाए। Proof of Life उस आदेश को अपने-आप लागू करता है, और हत्या की वजह ही खत्म कर देता है।",

  how_title: "यह कैसे काम करता है",
  how_1_t: "सील करें",
  how_1: "आपकी फ़ाइलें इसी ब्राउज़र में एन्क्रिप्ट होती हैं। Arkiv पर सिर्फ़ एन्क्रिप्टेड डेटा जाता है, और उसे ऐसे पते को सौंप दिया जाता है जिस पर किसी का नियंत्रण नहीं, इसलिए उसे कोई मिटा नहीं सकता, आप भी नहीं।",
  how_2_t: "संरक्षक चुनें",
  how_2: "कोई पत्रकार, वकील या दोस्त। हर एक के पास चाबी का एक टुकड़ा होता है। उनमें से कोई भी {k} मिलकर तिजोरी खोल सकते हैं; इससे कम को कुछ पता नहीं चलता।",
  how_3_t: "चेक-इन करें",
  how_3: "आपकी धड़कन Arkiv पर एक एंटिटी है जिसे सिर्फ़ आपकी चाबी ज़िंदा रख सकती है। एक टैप उसे आगे बढ़ा देता है। समय-सीमा और छूट की अवधि चूक गए, तो वह बस खत्म हो जाती है।",
  how_4_t: "जारी करें",
  how_4: "संरक्षक देखते हैं कि धड़कन रुक गई है और अपने टुकड़े प्रकाशित करते हैं। पर्याप्त टुकड़े सार्वजनिक होते ही कोई भी ब्राउज़र दस्तावेज़ खोल सकता है। कोई सर्वर फ़ैसला नहीं करता।",

  phase_alive: "ज़िंदा",
  phase_overdue: "देर हो गई",
  phase_lapsed: "धड़कन रुक गई",
  phase_releasing: "जारी हो रहा है",
  phase_released: "जारी हो गया",
  phase_alive_d: "चेक-इन हो गया। दस्तावेज़ सील रहेंगे।",
  phase_overdue_d: "चेक-इन का समय निकल गया। संरक्षकों को अभी कार्यकर्ता से संपर्क करने की कोशिश करनी चाहिए।",
  phase_lapsed_d: "समय-सीमा से पहले चेक-इन नहीं हुआ। संरक्षक अब अपने टुकड़े प्रकाशित कर सकते हैं।",
  phase_releasing_d: "{k} में से {have} टुकड़े सार्वजनिक हैं। {need} और मिलने पर तिजोरी खुल जाएगी।",
  phase_released_d: "पर्याप्त टुकड़े सार्वजनिक हैं। कोई भी ये दस्तावेज़ खोल सकता है।",

  t_due_in: "चेक-इन बाकी",
  t_lapses_in: "धड़कन रुकेगी",
  early_release: "चेतावनी: धड़कन चलते हुए ही एक संरक्षक ने अपना टुकड़ा प्रकाशित कर दिया। यह नियमों का उल्लंघन है। इस तिजोरी को असुरक्षित मानें।",

  v_custodians: "संरक्षक",
  v_custodian_slot: "स्लॉट {slot}",
  v_ack_live: "चाबी संभाले हुए · {time} में नवीनीकरण",
  v_ack_missing: "पुष्टि नहीं की",
  v_released_piece: "टुकड़ा प्रकाशित",
  v_open: "दस्तावेज़ खोलें",
  v_opening: "चाबी जोड़ी जा रही है और डिक्रिप्ट हो रहा है…",
  v_files: "दस्तावेज़",
  v_verified: "हर फ़ाइल ब्लॉक {block} पर सील किए गए हैश से मेल खाती है। ये दस्तावेज़ वैसे ही हैं जैसे {date} को थे।",
  v_sealed_yes: "सील: केवल-पढ़ने योग्य, और ऐसे पते के पास जिसकी चाबी किसी के पास नहीं",
  v_sealed_no: "सील नहीं: बनाने वाला अभी भी इसे मिटा सकता है",
  v_rejected: "अनदेखी की गई एंटिटी",
  v_rejected_d: "ये इस तिजोरी की होने का दावा करती हैं पर भरोसे की जाँच में फेल हैं। इन्हें कोई भी लिख सकता है; पर इन्हें गिनवा कोई नहीं सकता।",
  v_keepalive: "इस तिजोरी को आज से कम से कम एक साल ज़िंदा रखें",
  v_keepalive_d: "सील किए गए डेटा की उम्र कोई भी बढ़ा सकता है। आप थोड़ी-सी टेस्ट गैस देते हैं; कुछ बदल या मिटा नहीं सकते।",
  v_newsroom: "ये टुकड़े न्यूज़रूम की चाबी से सील हैं। सिर्फ़ वही न्यूज़रूम दस्तावेज़ खोलकर तय कर सकता है कि क्या छापना है।",
  v_live: "लाइव",
  v_events: "लाइव गतिविधि",

  use_title: "यह किसके लिए है, और किसके लिए नहीं",
  use_body: "Proof of Life उन लोगों की मदद करता है जो अपने कानूनी अधिकारों का इस्तेमाल करते हैं, जैसे RTI आवेदक, पत्रकार और वकील, ताकि उनके कानूनी रूप से हासिल किए गए रिकॉर्ड उनके बाद भी बचे रहें। RTI के जवाब, सार्वजनिक रिकॉर्ड और अपने सबूत सील करें। गोपनीय सरकारी सामग्री, दूसरों की निजी जानकारी, या ऐसा कुछ भी सील न करें जिसे रखना कानूनन मना हो। असली इस्तेमाल के लिए न्यूज़रूम को जारी करें, ताकि छपने से पहले संपादक दस्तावेज़ जाँच सकें। यह संस्करण टेस्ट नेटवर्क पर सिर्फ़ काल्पनिक दस्तावेज़ों के साथ चलता है।",
  hero_title_a: "मेरी धड़कन रुकी,",
  hero_title_b: "तो सच बाहर आएगा।",
  trust_1: "मुफ़्त और ओपन सोर्स",
  trust_2: "कोई वॉलेट या ऐप इंस्टॉल नहीं करना",
  why_h2_a: "सबूत मर जाता है",
  why_h2_b: "उसे ढूँढने वाले के साथ।",
  old_eyebrow: "आज",
  old_title: "लैपटॉप पर एक फ़ोल्डर और किसी दोस्त के पास एक कॉपी",
  old_1: "लैपटॉप ज़ब्त हो सकता है, ड्राइव मिटाई जा सकती है।",
  old_2: "जिस दोस्त के पास इकलौती कॉपी है, उसे डराकर चुप कराया जा सकता है।",
  old_3: "जब तक बहुत देर न हो जाए, किसी और को पता ही नहीं होता कि काग़ज़ मौजूद हैं।",
  new_eyebrow: "Proof of Life के साथ",
  new_title: "एक सील रिकॉर्ड जो अपने तय समय पर खुलता है",
  new_1: "एन्क्रिप्टेड रिकॉर्ड Arkiv पर रहता है, और कोई उसे मिटा नहीं सकता।",
  new_2: "रिलीज़ किसी एक व्यक्ति, सर्वर या कंपनी पर निर्भर नहीं है।",
  new_3: "कार्यकर्ता की हत्या से निष्कर्ष दबते नहीं, बाहर आ जाते हैं।",
  f1_title: "आपके फ़ोन पर एन्क्रिप्ट, Arkiv पर अमिट।",
  f2_title: "भरोसा आपके चुने लोगों में बँटा हुआ।",
  f3_title: "हफ़्ते में एक टैप, और सब सील रहता है।",
  f4_title: "धड़कन रुकते ही कोई भी पढ़ सकता है।",
  try_eyebrow: "इसी पेज पर आज़माएँ",
  try_h2: "एक साल के चेक-इन, एक मिनट में।",
  try_lead: "रिद्म चुनें और तय करें कि कितने संरक्षकों की सहमति चाहिए, फिर चेक-इन बंद करें और देखें क्या होता है। हर सेकंड एक दिन बीतता है।",
  sim_rhythm: "चेक-इन रिद्म",
  sim_k: "रिलीज़ के लिए ज़रूरी संरक्षक: {k}",
  sim_auto: "मैं चेक-इन करता/करती रहूँगा/गी",
  sim_auto_d: "चुप होने के लिए इसे बंद करें।",
  sim_checkin: "अभी चेक-इन करें",
  sim_reset: "फिर से शुरू करें",
  sim_note: "यह बॉक्स सिर्फ़ इस पेज पर सिमुलेशन है। ड्रिल यही चीज़ असली Arkiv टेस्टनेट पर चलाती है।",
  sim_due: "अगला चेक-इन {d} दिन में",
  arkiv_eyebrow: "यह Arkiv पर क्यों चलता है",
  arkiv_h2_a: "डेडलाइन डेटाबेस संभालता है।",
  arkiv_h2_b: "किसी को सर्वर चालू नहीं रखना पड़ता।",
  faq_eyebrow: "सवाल",
  faq_h2: "लोग सबसे पहले क्या पूछते हैं।",
  faq_1_q: "क्या कोई रिलीज़ रोक सकता है?",
  faq_1_a: "Arkiv डेडलाइन लागू करता है और एन्क्रिप्टेड रिकॉर्ड रखता है। रिलीज़ के लिए आपके k संरक्षकों को अपने टुकड़े प्रकाशित करने होते हैं। अगर उनमें से काफ़ी लोग चुप करा दिए जाएँ या मना कर दें, तो तिजोरी सील रहती है। इसीलिए अलग-अलग जगहों के लोग चुनें और k को कुल संख्या से कम रखें।",
  faq_2_q: "अगर मेरा फ़ोन खो जाए तो?",
  faq_2_a: "नए फ़ोन पर अपनी बैकअप फ़ाइल रीस्टोर करें और पासफ़्रेज़ डालें। बैकअप फ़ोन से दूर रखें, जैसे किसी भरोसेमंद व्यक्ति के पास। पासफ़्रेज़ के बिना वह बेमतलब टेक्स्ट है।",
  faq_3_q: "अगर कोई मुझे ज़बरदस्ती चेक-इन करवाए तो?",
  faq_3_a: "तिजोरी बनाते समय एक दबाव-पासफ़्रेज़ (duress) सेट करें। उससे किया गया चेक-इन बिल्कुल सामान्य दिखता है, आपकी स्क्रीन पर भी और सार्वजनिक पेज पर भी। हर चेक-इन के साथ संरक्षकों के लिए एक एन्क्रिप्टेड नोट जाता है, और यह नोट उन्हें तुरंत जारी करने को कहता है।",
  final_a: "अपने सबूत अकेले मत रखिए।",
  final_b: "उन्हें सील कीजिए, और चेक-इन करते रहिए।",
  final_cta_2: "जारी हुई तिजोरी देखें",
  common_loading: "Arkiv से पढ़ा जा रहा है…",
  common_error: "Arkiv से पढ़ नहीं सके",
  common_retry: "फिर कोशिश करें",
  common_copy: "कॉपी करें",
  common_copied: "कॉपी हो गया",
  common_testnet: "सिर्फ़ टेस्टनेट। यहाँ कभी असली निजी जानकारी सील न करें।",
  read_direct: "सीधे Arkiv से पढ़ रहे हैं",
  read_relay: "हमारे रिले से पढ़ रहे हैं (Arkiv की मुफ़्त सीमा पूरी हो गई)",
  vl_all: "सभी",
  vl_soon: "3 दिन में रुकने वाली",
  vl_slow: "हफ़्ते में एक या उससे कम चेक-इन",
  vl_filter_note: "ये फ़िल्टर Arkiv नोड पर हर धड़कन की समय-सीमा और हर तिजोरी के चेक-इन अंतराल पर रेंज क्वेरी के रूप में चलते हैं।",
  vl_rel_t: "जारी हुए सबूत",
  vl_rel_b: "वे तिजोरियाँ जिनके टुकड़े सार्वजनिक हैं। धड़कन चलते समय तिजोरी सूची से बाहर रह सकती है; हर जारी टुकड़े पर प्रोजेक्ट टैग और तिजोरी बनाने वाले का पता होता है, इसलिए जारी सबूत सिर्फ़ चेन से ढूँढे जा सकते हैं।",
  vl_pieces: "{n} टुकड़े · ब्लॉक {b} से",
  vl_intro: "Arkiv पर हर सूचीबद्ध तिजोरी, सीधे पढ़ी गई। तिजोरी सिर्फ़ एक बेतरतीब id, संरक्षकों की संख्या और अपनी धड़कन दिखाती है। यहाँ कुछ भी नहीं बताता कि इसे किसने बनाया या इसमें क्या है। रिलीज़ की गिनती में सिर्फ़ वे टुकड़े हैं जो तिजोरी की जाँच में पास होते हैं; नकली टुकड़े अलग से दिखते हैं।",
  vl_row: "{n} में से {k} संरक्षक · {mode} रिलीज़ · {by} द्वारा",
  rti_bk_t: "अगर दूसरी अपील तक जाना पड़े",
  rti_bk_lead: "दूसरी अपील आपके राज्य सूचना आयोग में जाती है, या केंद्र सरकार के दफ़्तर के लिए केंद्रीय सूचना आयोग में। अपना आयोग चुनें और देखें कि वहाँ कितने मामले अटके हैं।",
  rti_bk_pick: "सूचना आयोग",
  rti_bk_choose: "आयोग चुनें",
  rti_bk_wait: "1 जुलाई 2025 को दायर मामले के निपटारे का अनुमानित इंतज़ार: {wait}।",
  rti_bk_years: "{y} साल",
  rti_bk_years_months: "{y} साल {m} महीने",
  rti_bk_defunct: "7 अक्टूबर 2025 तक इस आयोग में कोई आयुक्त नहीं था, इसलिए अपीलें सुनने वाला कोई नहीं था।",
  rti_bk_nochief: "अक्टूबर 2025 में यह मुख्य सूचना आयुक्त के बिना काम कर रहा था।",
  rti_bk_reduced: "मामले बढ़ते रहे, फिर भी यह क़ानून में तय संख्या से कम आयुक्तों के साथ काम कर रहा था।",
  rti_bk_none: "रिपोर्ट के सारांश में इस आयोग का अलग आँकड़ा नहीं है।",
  rti_bk_all: "पूरे देश में 30 जून 2025 को {n} अपीलें और शिकायतें लंबित थीं, और 29 में से 18 आयोगों को 1 जुलाई 2025 को दायर मामला निपटाने में एक साल से ज़्यादा लगेगा। पहली अपील समय पर दायर करें: यही कदम आपके हाथ में है।",
  rti_bk_src: "स्रोत: सतर्क नागरिक संगठन, भारत में सूचना आयोगों के प्रदर्शन पर रिपोर्ट कार्ड, 2024-25 (प्रेस विज्ञप्ति, 9 अक्टूबर 2025)।",
  home_rti_n1: "17,50,863",
  home_rti_s1: "2023-24 में दायर RTI आवेदन, राज्यसभा में केंद्र सरकार के जवाब के अनुसार।",
  home_rti_n2: "4,13,972",
  home_rti_s2: "30 जून 2025 को भारत के 29 सूचना आयोगों में लंबित अपीलें और शिकायतें।",
  home_rti_n3: "29 साल",
  home_rti_s3: "तेलंगाना आयोग में 1 जुलाई 2025 को दायर मामले का अनुमानित इंतज़ार।",
  home_rti_next: "जिनके लिए RTI का काम ख़तरनाक हो जाए, उनके लिए अगली परत तिजोरी है।",
  hero_cta_rti: "अपनी RTI की समय-सीमा देखें",
  rti_tally_line: "इस आयोग के लिए इस घड़ी से दर्ज आवेदन: {n}, जिनमें से {late} की जवाब की समय-सीमा बीत चुकी है। गिनती सीधे Arkiv से।",
  rti_tally_zero: "इस आयोग के लिए अभी तक कोई आवेदन सार्वजनिक गिनती में नहीं जोड़ा गया है।",
  rti_tally_note: "आवेदक आवेदन दर्ज करते समय गिने जाना चुनते हैं। कोई भी गिनती में जोड़ सकता है, इसलिए इसे आवेदकों का संकेत मानें, आयोग का ऑडिट नहीं।",
  rti_tally_opt: "इस आवेदन को {name} की सार्वजनिक गिनती में भी, बिना नाम के, जोड़ें। Arkiv पर सिर्फ़ आयोग और जवाब की समय-सीमा जाती है।",
  rti_tally_pick: "इस आवेदन को किसी आयोग की सार्वजनिक गिनती में जोड़ने के लिए ऊपर अपना सूचना आयोग चुनें।",
  // Key, check-in, custodian and sealing flows
  nv_reused: "इनमें से एक निमंत्रण कोड पहले से किसी दूसरी तिजोरी की रखवाली करता है। उसे दोबारा इस्तेमाल करने से Arkiv पर आपकी तिजोरियाँ जुड़ जाएँगी। उस संरक्षक से नया निमंत्रण कोड माँगें।",
  kg_no_key_activist: "इस पासफ़्रेज़ से इस ब्राउज़र में कोई एक्टिविस्ट कुंजी नहीं खुलती।",
  kg_no_key_custodian: "इस पासफ़्रेज़ से इस ब्राउज़र में कोई संरक्षक कुंजी नहीं खुलती।",
  kg_short: "कम से कम 8 अक्षर रखें। एक छोटा वाक्य सबसे अच्छा है।",
  kg_differ: "दोनों पासफ़्रेज़ अलग हैं।",
  kg_ready_t: "आपकी कुंजी तैयार है",
  kg_ready_b: "एक बैकअप फ़ाइल अभी डाउनलोड हुई है। इसे इस फ़ोन से दूर रखें, जैसे किसी भरोसेमंद व्यक्ति के पास। आपके पासफ़्रेज़ के बिना यह बस कुछ बेतरतीब अक्षर हैं।",
  kg_ready_warn: "अगर यह ब्राउज़र और बैकअप दोनों खो जाएँ, तो आप चेक-इन नहीं कर पाएँगे और डेडलाइन बीतने पर तिजोरी जारी हो जाएगी। इसे ऐसे ही काम करना है।",
  kg_continue: "आगे बढ़ें",
  kg_again: "बैकअप फिर से डाउनलोड करें",
  kg_addr: "कुंजी का पता",
  kg_unlock: "खोलें",
  kg_unlocking: "खुल रहा है…",
  kg_new: "नई कुंजी बनाएँ",
  kg_restore: "बैकअप वापस लाएँ",
  kg_restored: "{n} कुंजी वापस आ गई। पासफ़्रेज़ डालें।",
  kg_pass: "पासफ़्रेज़",
  kg_label: "एक लेबल जो सिर्फ़ आप देखेंगे",
  kg_label_hint: "खोलने के बाद दिखता है, ताकि कुंजियाँ अलग पहचानी जा सकें। कभी असली नाम न लिखें।",
  kg_pass_hint: "कम से कम 8 अक्षर। ऐसा वाक्य जो सिर्फ़ आप लिखें, अच्छा रहता है। हर तिजोरी के लिए एक ही पासफ़्रेज़ रख सकते हैं।",
  kg_pass2: "पासफ़्रेज़ दोबारा",
  kg_duress: "दबाव-पासफ़्रेज़ (वैकल्पिक)",
  kg_duress_hint: "अगर कोई आपसे ज़बरदस्ती चेक-इन करवाए, तो यह वाला इस्तेमाल करें। चेक-इन आपकी स्क्रीन पर और सार्वजनिक पेज पर सामान्य दिखता है। उसका एन्क्रिप्टेड नोट आपके संरक्षकों को तुरंत जारी करने को कहता है। इस फ़ोन पर कुछ भी नहीं दिखाता कि दबाव-पासफ़्रेज़ मौजूद है।",
  kg_making: "कुंजी बन रही है…",
  kg_make: "कुंजी बनाएँ और उसका बैकअप डाउनलोड करें",
  ci_gate_t: "चेक-इन के लिए खोलें",
  ci_gate_i: "एक पासफ़्रेज़ इस ब्राउज़र की हर तिजोरी-कुंजी खोलता है।",
  ci_jitter_wait: "आपका चेक-इन लगभग {m} मिनट में जाएगा। यह पेज खुला रखें।",
  ci_done: "{time} पर चेक-इन हो गया। आपके दस्तावेज़ सील रहेंगे।",
  ci_busy: "चेक-इन हो रहा है…",
  ci_btn_one: "मैं सुरक्षित हूँ · 1 तिजोरी चेक-इन करें",
  ci_btn_many: "मैं सुरक्षित हूँ · {n} तिजोरियाँ चेक-इन करें",
  ci_jitter: "अगले 1 से 20 मिनट में किसी भी समय भेजें",
  ci_none: "इन कुंजियों की किसी तिजोरी में अब धड़कन नहीं है।",
  ci_key: "कुंजी",
  ci_due: "अगला चेक-इन {d} में",
  ci_grace: "आप छूट की अवधि में हैं। अभी चेक-इन करें।",
  cu_title: "संरक्षक",
  cu_intro: "आपके पास एक कुंजी का एक टुकड़ा है। अकेले यह कुछ नहीं खोलता। आप दो वादे करते हैं: धड़कन देर होने पर एक्टिविस्ट से संपर्क करने की कोशिश करेंगे, और धड़कन रुकने पर अपना टुकड़ा प्रकाशित करेंगे। हर तिजोरी के लिए नई कुंजी लें, ताकि Arkiv पर कुछ भी आपकी तिजोरियों को आपस में या आपसे न जोड़े।",
  cu_gate_stored: "अपनी संरक्षक कुंजियाँ खोलें, या नई तिजोरी के लिए एक बनाएँ",
  cu_gate_new: "एक तिजोरी के लिए संरक्षक कुंजी बनाएँ",
  cu_another: "एक और संरक्षक कुंजी बनाएँ",
  cu_invite: "निमंत्रण कोड",
  cu_invite_b: "इसे एक्टिविस्ट को ऐसे रास्ते से भेजें जिस पर आप दोनों भरोसा करते हों। इसमें इस कुंजी का सिर्फ़ सार्वजनिक हिस्सा है।",
  cu_looking: "इस कुंजी वाली तिजोरियाँ खोजी जा रही हैं…",
  cu_none: "अभी किसी तिजोरी में यह कुंजी नहीं है। जब एक्टिविस्ट आपके निमंत्रण कोड से तिजोरी सील करेंगे, वह यहाँ दिखेगी।",
  cu_slot: "{n} में से स्लॉट {slot} · जारी करने के लिए {k} चाहिए",
  cu_duress: "एक्टिविस्ट का पिछला चेक-इन दबाव-पासफ़्रेज़ से हुआ था। यह सिर्फ़ आप और दूसरे संरक्षक देख सकते हैं। अपना टुकड़ा अभी प्रकाशित करें।",
  cu_overdue: "एक्टिविस्ट देर से हैं। तय किए गए रास्ते से अभी उनसे संपर्क करें।",
  cu_renewed: "संरक्षण 14 दिन के लिए बढ़ गया।",
  cu_confirmed: "संरक्षण की पुष्टि हो गई।",
  cu_renew: "संरक्षण बढ़ाएँ ({left} बाकी)",
  cu_confirm: "पुष्टि करें कि मेरे पास कुंजी है",
  cu_published: "आपका टुकड़ा सार्वजनिक हो गया।",
  cu_piece_done: "टुकड़ा प्रकाशित",
  cu_publish: "मेरा टुकड़ा प्रकाशित करें",
  cu_early: "धड़कन रुकने के बाद ही प्रकाशन खुलता है। ऐप और CLI दोनों पहले मना करते हैं, और पहले प्रकाशित टुकड़ा तिजोरी पेज पर चिह्नित होता है।",
  cu_watch_t: "अपना ख़ुद का वॉचर चलाएँ",
  cu_watch_b: "यह पेज खुला रखने की ज़रूरत नहीं। आपके अपने कंप्यूटर पर एक वॉचर, या आपके अपने GitHub खाते पर हर घंटे चलने वाला काम, आपका संरक्षण बढ़ाता है और धड़कन रुकते ही या दबाव-चेक-इन आते ही आपका टुकड़ा प्रकाशित करता है। इसमें हमारा कुछ भी शामिल नहीं। एक्टिविस्ट देर करें तो काम विफल होता है और GitHub आपको ईमेल करता है।",
  cu_watch_link: "वॉचर सेट करें",
  nv_rh_daily: "हर दिन",
  nv_rh_weekly: "हर हफ़्ते",
  nv_rh_fortnight: "हर दो हफ़्ते",
  nv_rh_monthly: "हर महीने",
  nv_rh_test: "टेस्ट: हर 10 मिनट",
  nv_gate_t: "इस तिजोरी के लिए नई कुंजी",
  nv_gate_i: "हर तिजोरी की अपनी कुंजी होती है। Arkiv पर एक कुंजी ने जो कुछ लिखा, वह एक क्वेरी से दिख सकता है, इसलिए हर तिजोरी की नई कुंजी से कोई नहीं जान सकता कि दो तिजोरियाँ एक ही व्यक्ति की हैं। सबके लिए एक ही पासफ़्रेज़ रख सकते हैं।",
  nv_enc: "इस ब्राउज़र में {n} फ़ाइल एन्क्रिप्ट हुईं; {c} एन्क्रिप्टेड हिस्से।",
  nv_owngas_wait: "अपने वॉलेट या फ़ॉसेट से Arkiv Tiramisu पर {addr} को कम से कम {glm} GLM भेजें। इंतज़ार हो रहा है…",
  nv_chunk: "हिस्सा {d}/{t} सील हुआ",
  nv_manifest: "मैनिफ़ेस्ट, लिफ़ाफ़े और धड़कन एक साथ सील हुए",
  nv_done_t: "सील हो गया। आपकी धड़कन शुरू हो गई है।",
  nv_done_b: "{i} के अंदर चेक-इन करें। उसके बाद {g} की छूट है।",
  nv_send_link: "यह लिंक हर संरक्षक को भेजें",
  nv_open: "तिजोरी का पेज खोलें",
  nv_checkin: "चेक-इन पेज",
  nv_s1: "1 · दस्तावेज़",
  nv_s1_b: "कम्प्रेशन के बाद लगभग 1.4 MB तक। RTI जवाबों की फ़ोटो पहले इसी फ़ोन पर छोटी की जाती हैं, इसलिए कई पन्नों का जवाब आमतौर पर आ जाता है। इस टेस्टनेट पर सिर्फ़ टेस्ट दस्तावेज़।",
  nv_count: "{n} फ़ाइल · {size}",
  nv_too_big: "बहुत बड़ा है। कुल 1.4 MB से कम रखें।",
  nv_title_l: "शीर्षक (एन्क्रिप्टेड, जारी होने के बाद ही पढ़ा जा सकता है)",
  nv_note_l: "जारी होने के बाद पढ़ने वाले के लिए एक नोट (एन्क्रिप्टेड)",
  nv_s2: "2 · संरक्षक",
  nv_s2_b: "हर व्यक्ति से कहें कि वे संरक्षक पेज खोलें और आपको अपना निमंत्रण कोड भेजें। हर कोड सिर्फ़ आपकी तिजोरी के लिए बनी नई कुंजी है, इसलिए Arkiv पर कुछ भी उसे उनकी पहचान से नहीं जोड़ता।",
  nv_add: "संरक्षक जोड़ें",
  nv_dup: "एक ही संरक्षक दो बार है।",
  nv_k: "जारी करने के लिए कितनों को साथ आना होगा: {n} में से {k}",
  nv_k_hint: "दो या ज़्यादा रखने से कोई एक संरक्षक अकेले कुछ नहीं कर सकता। सबसे कम रखने से किसी एक के न मिलने पर भी काम चलता है।",
  nv_s3: "3 · लय और जारी करना",
  nv_grace: "छूट {d}",
  nv_public: "सबके लिए जारी करें। काफ़ी टुकड़े आने पर कोई भी दस्तावेज़ खोल सकता है।",
  nv_newsroom: "एक न्यूज़रूम को जारी करें। टुकड़े उसकी कुंजी पर सील होते हैं; प्रकाशन से पहले उसके संपादक दस्तावेज़ जाँचते हैं।",
  nv_newsroom_ph: "न्यूज़रूम की सार्वजनिक कुंजी, 0x02… या 0x03…",
  nv_anyone_t: "किसी को भी सबूत ज़िंदा रखने दें",
  nv_anyone_b: "सुझाया गया। जारी होने के बाद समर्थक एन्क्रिप्टेड डेटा की उम्र बढ़ा सकते हैं, ताकि वह आपके बाद भी रहे। बंद करें तो उसकी उम्र सिर्फ़ आपके हाथ में रहेगी।",
  nv_owngas_t: "गैस अपने वॉलेट से दें",
  nv_owngas_b: "बंद: एक साझा टैप इस कुंजी को थोड़ा टेस्ट GLM भेजता है, और टैप का पता हर फ़ंड की गई कुंजी को जोड़ता है। चालू: इस कुंजी को GLM ख़ुद भेजें, जैसे फ़ॉसेट के \"Use a different address\" से।",
  nv_listed_t: "इस तिजोरी को सार्वजनिक सूची में डालें",
  nv_listed_b: "डिफ़ॉल्ट रूप से बंद। बिना सूची वाली तिजोरी पर न प्रोजेक्ट टैग होता है न साफ़ टाइप, इसलिए कोई खोज उसे नहीं दिखाती। पूरी चेन स्कैन करने वाला फिर भी देख सकता है कि कोई तिजोरी है, पर यह कभी नहीं कि उसमें क्या है या वह किसकी है।",
  nv_what: "Arkiv पर क्या जाता है",
  nv_pub_h: "सार्वजनिक, हमेशा पढ़ने योग्य",
  nv_you_h: "आपके पास रहता है",
  nv_r1a: "एन्क्रिप्टेड हिस्से और उनके हैश",
  nv_r1b: "फ़ाइलें, शीर्षक, नोट",
  nv_r2a: "हर संरक्षक का एक-बार का पता और सार्वजनिक कुंजी",
  nv_r2b: "संरक्षक कौन हैं",
  nv_r3a: "आपकी धड़कन और उसकी डेडलाइन",
  nv_r3b: "आपकी कुंजी और पासफ़्रेज़",
  nv_r4a: "{n} में से {k}, लय, जारी करने का तरीका",
  nv_r4b: "जो कुछ भी आपका नाम बताए, और तिजोरी को दिया कोई भी लेबल",
  nv_watch: "चेन पर नज़र रखने वाला देख सकता है कि आप कब चेक-इन करते हैं, और Arkiv नोड वह IP पता देखता है जहाँ से आप चेक-इन करते हैं। उन समयों पर चेक-इन करें जब आप वैसे भी ऑनलाइन होते हैं, Tor या पहले से इस्तेमाल होने वाले VPN से।",
  nv_agree: "मैं समझता/समझती हूँ कि सील होने के बाद यह तिजोरी कोई नहीं मिटा सकता, मैं भी नहीं, और चेक-इन छूटने पर यह जारी हो जाएगी। ये क़ानूनी तरीके से पाए गए रिकॉर्ड हैं, इनमें कोई गोपनीय सामग्री या किसी दूसरे व्यक्ति की निजी जानकारी नहीं है।",
  nv_sealing: "सील हो रहा है…",
  nv_seal: "सील करें और मेरी धड़कन शुरू करें",

  dr_kicker: "पाँच मिनट की ड्रिल",
  dr_title: "एक तिजोरी को जीते, रुकते और बोलते देखिए।",
  dr_body: "यह टैब एक एक्टिविस्ट और तीन संरक्षकों का काम करता है। हर कदम Arkiv के Tiramisu टेस्टनेट पर असली लेन-देन है, और हर एक का लिंक साथ में है। घड़ी छोटी कर दी गई है: हर मिनट चेक-इन, एक मिनट की छूट।",
  dr_note_label: "सिंथेटिक RTI जवाब के साथ सील करने के लिए एक पंक्ति",
  dr_note_default: "असली आँकड़े माप-पुस्तिका के पेज 14 पर हैं।",
  dr_unreachable: "ज़रूरत के वक़्त संरक्षक 2 से संपर्क नहीं हो पाता",
  dr_forge: "एक जालसाज़ नकली टुकड़ा प्रकाशित करने की कोशिश करता है",
  dr_start: "ड्रिल शुरू करें",
  dr_public: "तिजोरी का सार्वजनिक पेज →",
  dr_due: "अगला चेक-इन:",
  dr_now: "अभी",
  dr_stops: "धड़कन रुकने में:",
  dr_pieces: "{k} में से {have} टुकड़े सार्वजनिक",
  dr_checkin: "चेक-इन करें",
  dr_force: "ज़बरदस्ती मिटवाएँ",
  dr_or: "या कुछ न दबाएँ और समय निकल जाने दें।",
  dr_out_t: "दस्तावेज़ बाहर आ गए।",
  dr_out: "सार्वजनिक पेज किसी दूसरे ब्राउज़र, दूसरे फ़ोन या CLI से खोलें। वह Arkiv पर रखे टुकड़ों से चाबी फिर से बनाता है और दस्तावेज़ खोलता है, इस टैब या हमारे सर्वर की मदद के बिना।",
  dr_open: "तिजोरी का सार्वजनिक पेज खोलें",
  dr_log_t: "Arkiv पर अभी क्या हुआ",
  dr_log_none: "अभी कुछ नहीं।",
  dr_activist: "एक्टिविस्ट",
  dr_c1: "संरक्षक 1 · पत्रकार",
  dr_c2: "संरक्षक 2 · वकील",
  dr_c3: "संरक्षक 3 · दोस्त",
  dr_forger: "जालसाज़",
  dr_l_keys: "इस टैब में 5 नई चाबियाँ बनीं। एक्टिविस्ट {a}।",
  dr_l_tap: "एक्टिविस्ट को टैप से टेस्ट गैस मिली।",
  dr_l_gas: "{name} को गैस",
  dr_l_enc: "ब्राउज़र में 2 फ़ाइलें एन्क्रिप्ट हुईं। चाबी 3 में से 2 के हिसाब से बँटी। तिजोरी {v}।",
  dr_l_chunk: "एन्क्रिप्टेड हिस्सा {d}/{t} लिखा और सील हुआ",
  dr_l_batch: "मैनिफ़ेस्ट, 3 लिफ़ाफ़े और धड़कन एक ही बैच में लिखे गए",
  dr_l_ack: "{name} ने चाबी रखने की पुष्टि की",
  dr_l_beat: "एक्टिविस्ट ने चेक-इन किया",
  dr_l_coerce: "दबाव: एक्टिविस्ट से ज़बरदस्ती धड़कन मिटवाई जाती है। इससे वह बस जल्दी रुक जाती है।",
  dr_l_gone: "संरक्षकों की निगरानी: धड़कन नहीं मिली। जारी कर रहे हैं।",
  dr_l_fake: "एक जालसाज़ ने स्लॉट 2 का नकली टुकड़ा प्रकाशित किया",
  dr_l_unreach: "संरक्षक 2 से संपर्क नहीं हो रहा। 3 में से 2 फिर भी काफ़ी हैं।",
  dr_l_piece: "{name} ने एक टुकड़ा प्रकाशित किया",
  vf_lead: "अगर यह वेबसाइट कल गायब हो जाए, तब भी हर तिजोरी Arkiv पर रहेगी, और इनमें से कोई भी उसे पढ़ सकता है।",
  vf_cli_t: "CLI",
  vf_cli: "टर्मिनल से स्थिति देखें, निगरानी करें, जारी करें और खोलें। न ब्राउज़र चाहिए, न साइट।",
  vf_curl: "{rpc} को एक JSON-RPC कॉल।",
  vf_src_t: "सोर्स कोड",
  vf_src: "MIT लाइसेंस, और /arkiv/schema.md में डेटा का पूरा ब्योरा, ताकि कोई भी अपना रीडर बना सके।",
  vf_run_t: "एक क्वेरी चलाएँ",
  vf_run: "Arkiv पर चलाएँ",
  why_1_n: "107+",
  why_3_n: "0",
  t_ago: "पहले",
  common_tx: "लेन-देन",
  common_block: "ब्लॉक",
  f1_chip_2: "बनाते समय हैश सील",
  f2_chip_1: "n में से k",
  f2_chip_2: "हर तिजोरी के लिए नई संरक्षक चाबी",
  f2_chip_3: "न्यूज़रूम को जारी",
  f3_chip_1: "हर हफ़्ते या हर महीने",
  f3_chip_2: "छूट की अवधि",
  f3_chip_3: "दबाव-पासफ़्रेज़",
  f4_chip_1: "नकली टुकड़े नहीं गिने जाते",
  f4_chip_2: "किसी भी ब्राउज़र में खुलता है",
  tile_1_t: "समय-सीमा, जिसे डेटाबेस ख़ुद लागू करता है",
  tile_1: "धड़कन एक Arkiv एंटिटी है जो एक अंतराल और छूट तक रहती है। अगर कोई उसे आगे न बढ़ाए, तो Arkiv उसे हटा देता है।",
  tile_2_t: "डेटा जिसे कोई मिटा नहीं सकता",
  tile_2: "हर सील किया हुआ हिस्सा सिर्फ़ पढ़ा जा सकता है, और लिखे जाने वाले ब्लॉक से ही एक ऐसे पते का है जिसकी चाबी किसी के पास नहीं।",
  tile_3_t: "लिखने वाले की पहचान, जिसकी नकल नहीं हो सकती",
  tile_3: "कोई टुकड़ा तभी गिना जाता है जब उसे ऑन-चेन बनाने वाला उसी स्लॉट का तय संरक्षक हो।",
  tile_4_t: "हमारे बिना भी पढ़ा जा सकता है",
  tile_4: "यह साइट, कमांड-लाइन टूल और एक curl कमांड, तीनों वही सार्वजनिक एंटिटी पढ़ते हैं।",
  tile_5_t: "WebSocket पर लाइव",
  tile_5: "चेक-इन और रिलीज़ हर खुले तिजोरी पेज पर उसी पल दिखते हैं जब वे चेन पर आते हैं।",
  tile_6_t: "आपके फ़ोन पर कुछ नहीं रखा जाता",
  tile_6: "चाबियाँ आपके पासफ़्रेज़ से सील रहती हैं, और ऐप सूची रखने के बजाय आपकी तिजोरियाँ Arkiv पर ढूँढता है।",
  faq_4_q: "क्या कोई संरक्षक मेरे दस्तावेज़ पहले पढ़ सकता है?",
  faq_4_a: "एक टुकड़े से कुछ पता नहीं चलता। धड़कन चलते हुए प्रकाशित टुकड़े तिजोरी के पेज पर समय से पहले जारी किए गए के रूप में दिखते हैं, और k से कम टुकड़ों से फिर भी कुछ नहीं खुलता।",
  faq_5_q: "चेन पर नज़र रखने वाले को क्या दिखता है?",
  faq_5_a: "रैंडम आईडी, एन्क्रिप्टेड डेटा, एक समय-सीमा और आपके चेक-इन का समय। नाम, शीर्षक, या कौन-सी तिजोरियाँ एक ही व्यक्ति की हैं, यह नहीं दिखता। चेक-इन का समय दिखता है, इसलिए उन्हीं समयों पर चेक-इन करें जब आप वैसे भी ऑनलाइन रहते हैं।",
  faq_6_q: "क्या यह क़ानूनी है?",
  faq_6_a: "यह उन रिकॉर्ड के लिए एन्क्रिप्शन सॉफ़्टवेयर है जिन्हें रखने का आपको हक़ है, जैसे RTI जवाब, सार्वजनिक रिकॉर्ड और आपके अपने सबूत। गोपनीय सामग्री या दूसरों की निजी जानकारी सील न करें। असली इस्तेमाल में न्यूज़रूम को जारी करें, ताकि कुछ भी छपने से पहले संपादक दस्तावेज़ जाँच लें।",
  faq_7_q: "टेस्ट नेटवर्क क्यों?",
  faq_7_a: "यह बिल्ड Arkiv Global Tour Stop के लिए Arkiv के Tiramisu टेस्टनेट पर चलता है। सिर्फ़ सिंथेटिक दस्तावेज़ इस्तेमाल करें।",
  vp_on_arkiv: "Arkiv पर",
  vp_chunks: "{n} एन्क्रिप्टेड हिस्से, {size}, सील करने वाला",
  vp_envelopes: "{n} में से {have} चाबी-लिफ़ाफ़े सील",
  vp_kept: "तिजोरी का डेटा ब्लॉक {b} तक रखा गया है (~{d})",
  vp_sealed_at: "ब्लॉक {b} पर सील हुआ · {date}",
  vp_waiting: "चेक-इन, पुष्टियों और रिलीज़ का इंतज़ार…",
  vp_mismatch: "कुछ फ़ाइलें अपने सील किए गए हैश से मेल नहीं खातीं।",
  vp_download: "डाउनलोड",
  ka_gas: "टेस्ट गैस ली जा रही है…",
  ka_none: "सब कुछ पहले से कम से कम एक साल के लिए रखा गया है।",
  ka_extending: "सील की गई {n} एंटिटी आगे बढ़ाई जा रही हैं…",
  ka_done: "हो गया",
  as_t: "किसी पिछले ब्लॉक पर",
  as_d: "वही क्वेरी, Arkiv के atBlock से किसी पिछले ब्लॉक पर पढ़ी गई। इससे साबित होता है कि उस पल तिजोरी किस हालत में थी, जैसे कि एक्टिविस्ट तब भी चेक-इन कर रहा था।",
  as_read: "पढ़ें",
  as_reading: "पढ़ा जा रहा है…",
  as_at: "ब्लॉक {b} पर: {phase}",
  as_hb: ", धड़कन ब्लॉक {b} तक वैध",
  as_nohb: ", कोई धड़कन नहीं",
  as_pieces: ", {n} वैध टुकड़े।",
  vy_t: "हमारे बिना इसे जाँचें",
  vy_d: "इस पेज की हर बात इन्हीं Arkiv क्वेरी से आती है। इन्हें किसी भी Arkiv एंडपॉइंट पर चलाएँ।",
  ev_checkin: "ब्लॉक {b} पर चेक-इन",
  ev_activity: "ब्लॉक {b} पर संरक्षक की गतिविधि",
  ev_deadline: "समय-सीमा पूरी; धड़कन जाँची जा रही है",
  hm_read: "Arkiv से पढ़ा गया",
  hm_at: "ब्लॉक {b} पर",
  hm_custodian: "संरक्षक {n}",
  hm_holding: "चाबी इनके पास है",
  hm_f1_t: "चेक-इन मिला",
  hm_f1: "धड़कन आगे बढ़ी",
  hm_f2_t: "3 लिफ़ाफ़े सील",
  hm_f2: "मालिक 0x…dEaD · कोई मिटा नहीं सकता",
  hm_f3_t: "संरक्षक 2 ने चाबी रखने की पुष्टि दोहराई",
  hm_f3: "लीज़ 14 दिन बढ़ी",
  mk_enc: "इसी ब्राउज़र में एन्क्रिप्ट",
  mk_chunk: "हिस्सा {i}",
  mk_sealed: "सील",
  mk_2of3: "3 में से 2 तिजोरी खोलते हैं",
  mk_journalist: "पत्रकार",
  mk_lawyer: "वकील",
  mk_friend: "दोस्त",
  mk_slot: "स्लॉट {n}",
  mk_piece: "चाबी का एक टुकड़ा, एक बार के पते पर एन्क्रिप्ट",
  mk_any2: "कोई भी दो टुकड़े चाबी फिर से बना देते हैं। अकेला एक टुकड़ा बस बेतरतीब शोर है।",
  mk_next: "अगला चेक-इन बाकी",
  mk_safe: "मैं सुरक्षित हूँ · चेक-इन",
  mk_stopped: "ब्लॉक {b} पर धड़कन रुकी",
  mk_published: "टुकड़ा प्रकाशित",
  mk_stranger: "{a} (अजनबी)",
  mk_ignored: "नहीं गिना: गलत निर्माता",
  mk_matches: "ब्लॉक {b} पर सील किए गए हैश से मेल खाता है",
  rh_week: "हर हफ़्ते",
  rh_fortnight: "हर पखवाड़े",
  rh_month: "हर महीने",
  vp_rhythm: "हर {i} · छूट {g} · {n} में से {k} संरक्षक · {mode}",
  vp_mode_newsroom: "न्यूज़रूम को जारी",
  vp_mode_public: "सार्वजनिक रिलीज़",
  rj_vault: "किसी दूसरे निर्माता की तिजोरी एंटिटी",
  rj_manifest: "उसी तिजोरी का दूसरा मैनिफ़ेस्ट; पहला ही गिना जाता है",
  rj_heartbeat: "धड़कन तिजोरी बनाने वाले ने नहीं लिखी",
  rj_beat: "चेक-इन नोट तिजोरी बनाने वाले ने नहीं लिखा",
  rj_envelope: "लिफ़ाफ़ा तिजोरी बनाने वाले ने नहीं लिखा",
  rj_ack: "पुष्टि ऐसे वॉलेट से जो इस स्लॉट का संरक्षक नहीं है",
  rj_release: "रिलीज़ ऐसे वॉलेट से जो इस स्लॉट का संरक्षक नहीं है",
  nav_rti: "RTI घड़ी",
  home_rti_eyebrow: "RTI लगाई है?",
  home_rti_h2: "जानिए जवाब किस दिन तक आना चाहिए।",
  home_rti_lead: "लोक सूचना अधिकारी को आवेदन मिलने की तारीख डालिए। RTI घड़ी सूचना का अधिकार अधिनियम के हिसाब से जवाब की आख़िरी तारीख और दोनों अपीलों की समय-सीमा बताती है, और जवाब न आने पर हिंदी, अंग्रेज़ी या तेलुगु में प्रथम अपील का मसौदा बना देती है। यह आज ही किसी भी फ़ोन पर चलती है, और आप जो लिखते हैं वह आपके ब्राउज़र में ही रहता है।",
  home_rti_cta: "RTI घड़ी खोलें",
  rti_eyebrow: "RTI घड़ी",
  rti_title: "आपकी RTI का जवाब कब तक आना चाहिए?",
  rti_lead: "लोक सूचना अधिकारी (PIO) को आपका आवेदन कब मिला, यह डालिए। सूचना का अधिकार अधिनियम, 2005 के तहत जवाब की आख़िरी तारीख और अपील की समय-सीमाएँ यहाँ दिखेंगी, और अगर तारीख बिना जवाब के निकल जाए तो प्रथम अपील का मसौदा भी। आप जो लिखते हैं वह इसी ब्राउज़र में रहता है।",
  rti_form_t: "आपका आवेदन",
  rti_received: "PIO को आवेदन मिलने की तारीख",
  rti_received_hint: "डाक से भेजा हो तो इंडिया पोस्ट ट्रैकिंग में डिलीवरी की तारीख डालें। ऑनलाइन आवेदन में यह तारीख पावती पर होती है।",
  rti_time: "समय",
  rti_kind: "आवेदन किस बारे में है",
  rti_kind_normal: "बाकी सब: 30 दिन",
  rti_kind_life: "किसी व्यक्ति का जीवन या स्वतंत्रता: 48 घंटे",
  rti_apio: "मैंने सहायक लोक सूचना अधिकारी (APIO) को दिया था (5 दिन और)",
  rti_fee: "PIO के शुल्क पत्र और आपके भुगतान के बीच के दिन",
  rti_fee_hint: "अगर PIO ने अतिरिक्त शुल्क नहीं माँगा तो इसे 0 रहने दें। वे दिन समय-सीमा में नहीं गिने जाते, धारा 7(3)(क)।",
  rti_tl_t: "आपकी समय-सीमाएँ",
  rti_due: "जवाब की आख़िरी तारीख",
  rti_due_s: "तब तक PIO को सूचना देनी है, या कारण बताकर मना करना है। धारा 7(1)",
  rti_due_apio: "इसमें सहायक PIO के 5 दिन शामिल हैं। धारा 5(2)",
  rti_deemed: "अगर कुछ न आए",
  rti_deemed_s: "अगले दिन से चुप्पी को इनकार माना जाता है और आप अपील कर सकते हैं। देर से जवाब आए तो सूचना मुफ़्त मिलनी चाहिए। धारा 7(2), 7(6)",
  rti_fa: "प्रथम अपील की आख़िरी तारीख",
  rti_fa_s: "प्रथम अपील प्राधिकारी को, यानी उसी लोक प्राधिकरण में PIO से वरिष्ठ अधिकारी को। पर्याप्त कारण हो तो देर से की गई अपील भी स्वीकार हो सकती है। धारा 19(1)",
  rti_faa: "अपील पर फ़ैसले की तारीख",
  rti_faa_s: "अपील मिलने के 30 दिन के भीतर, ज़्यादा से ज़्यादा 45 दिन। यहाँ {date} से गिना गया है। धारा 19(6)",
  rti_sa: "द्वितीय अपील की आख़िरी तारीख",
  rti_sa_s: "केंद्रीय या राज्य सूचना आयोग को, उस तारीख से 90 दिन के भीतर जब प्रथम अपील का फ़ैसला आना था या आपको मिला। धारा 19(3)",
  rti_left: "{n} बाकी",
  rti_passed: "समय-सीमा तक कोई जवाब नहीं",
  rti_source: "इस पेज की हर समय-सीमा सूचना का अधिकार अधिनियम, 2005 से ली गई है और केंद्र व राज्य दोनों के लोक प्राधिकरणों पर लागू होती है। शुल्क और फ़ॉर्म हर राज्य में अलग हो सकते हैं, पर ये समय-सीमाएँ अधिनियम में तय हैं।",
  rti_source_link: "इंडिया कोड पर अधिनियम पढ़ें",
  rti_rec_t: "Arkiv पर समय की मुहर लगाएँ",
  rti_rec_lead: "यह वैकल्पिक है। आवेदन की फ़ाइल चुनें या उसका पाठ चिपकाएँ। यह ब्राउज़र उसका SHA-256 फ़िंगरप्रिंट निकालता है और उसे इसी डिवाइस पर बने 32-बाइट के एक रैंडम सॉल्ट के साथ मिलाता है। चेन पर सिर्फ़ यह सॉल्ट मिला मान और जवाब की आख़िरी तारीख वाला ब्लॉक जाता है। सॉल्ट के बिना कोई भी किसी अनुमानित दस्तावेज़ या नाम को इससे मिलाकर नहीं देख सकता, इसलिए रिकॉर्ड से न यह पता चलता है कि आपने क्या माँगा, न यह कि आप कौन हैं। इसे कोई बदल या मिटा नहीं सकता, न आप, न हम। जिस ब्लॉक में यह लिखा गया, वह दिखाता है कि आवेदन तब तक मौजूद था। यह अपील की पूरी अवधि में पढ़ा जा सकता है और जवाब की आख़िरी तारीख के 165 दिन बाद, द्वितीय अपील की समय-सीमा ख़त्म होने पर, अपने आप ख़त्म हो जाता है (धारा 19(1), 19(6), 19(3))।",
  rti_rec_net: "यह Arkiv के Tiramisu टेस्टनेट पर चलता है। डाक या ऑनलाइन पावती भी सँभालकर रखें: PIO को आवेदन मिलने का सबूत वही है।",
  rti_rec_file: "आवेदन की फ़ाइल",
  rti_rec_text: "या आवेदन का पाठ चिपकाएँ",
  rti_rec_hash: "फ़िंगरप्रिंट (SHA-256)। यह इसी डिवाइस पर रहता है।",
  rti_rec_go: "Arkiv पर दर्ज करें",
  rti_rec_gas: "एक बार की कुंजी के लिए टेस्ट गैस ले रहे हैं…",
  rti_rec_write: "रिकॉर्ड लिख रहे हैं…",
  rti_rec_late: "जवाब की आख़िरी तारीख निकल चुकी है, इसलिए अब का रिकॉर्ड किसी समय-सीमा को नहीं मापेगा। नीचे अपील का मसौदा फिर भी बना सकते हैं।",
  rti_rec_t2: "Arkiv पर",
  rti_rec_by: "ब्लॉक {block} में दर्ज, {time}, एक बार की कुंजी {addr} से।",
  rti_rec_live: "जवाब की आख़िरी तारीख ब्लॉक {due} पर है। रिकॉर्ड ब्लॉक {block} तक रहेगा, यानी 165 दिन बाद, जब आख़िरी अपील की समय-सीमा ख़त्म होती है (धारा 19(1), 19(6), 19(3))।",
  rti_rec_gone: "ब्लॉक {block} पर ख़त्म हुआ, जब आख़िरी अपील की समय-सीमा पूरी हुई। यहाँ ब्लॉक {at} की स्थिति पढ़ी गई है।",
  rti_rec_none: "हर बार दर्ज करने पर नया सॉल्ट बनता है। एक आवेदन एक ही बार दर्ज करें और उसकी रसीद रखें।",
  rti_rec_link: "यह लिंक सँभालकर रखें। इससे किसी भी डिवाइस पर यह रिकॉर्ड और आपकी समय-सीमाएँ फिर खुलेंगी।",
  rti_rec_tx: "ट्रांज़ैक्शन",
  rti_rec_rejected: "इस टैग वाली {n} एंटिटी जाँच में फ़ेल हुईं और छोड़ दी गईं।",
  rti_rec_receipt_s: "रसीद अभी डाउनलोड करें और आवेदन के साथ रखें। इसमें सॉल्ट है, जो और कहीं नहीं है। रसीद और आवेदन से कोई भी जाँच सकता है कि यह रिकॉर्ड आपका है; रसीद के बिना रिकॉर्ड किसी चीज़ से मिलाया नहीं जा सकता।",
  rti_rec_receipt: "रसीद डाउनलोड करें",
  rti_rec_commit: "Arkiv पर सॉल्ट मिला मान:",
  rti_rec_needreceipt: "यह दिखाने के लिए कि रिकॉर्ड किसी आवेदन का है, उसकी रसीद खोलें और ऊपर आवेदन चुनें।",
  rti_rec_badreceipt: "यह फ़ाइल Proof of Life की RTI रसीद नहीं है, या इसका सॉल्ट इसमें लिखा मान नहीं देता।",
  rti_rec_nomatch: "यह आवेदन रसीद से मेल नहीं खाता।",
  rti_rec_norecord: "Arkiv पर इस रसीद के मान वाला कोई मान्य रिकॉर्ड नहीं मिला।",
  rti_rec_match: "यह आवेदन रसीद से मेल खाता है, और रसीद Arkiv के रिकॉर्ड से।",
  rti_rec_open: "पहले दर्ज किया था? अपनी रसीद खोलें:",
  rti_letter_t: "प्रथम अपील, भेजने के लिए तैयार",
  rti_letter_early: "अभी जवाब की तारीख नहीं आई है। जवाब न आए तो आप यही पत्र भेजेंगे।",
  rti_letter_lead: "जो पता है वह भरें। खाली जगहें कोष्ठक में रहेंगी, उन्हें हाथ से भर लें। यहाँ से कुछ भी कहीं नहीं भेजा जाता।",
  rti_l_lang: "पत्र की भाषा",
  rti_l_name: "आपका नाम",
  rti_l_addr: "आपका पता",
  rti_l_auth: "लोक प्राधिकरण",
  rti_l_pio: "PIO का नाम या पदनाम",
  rti_l_reg: "आवेदन या पंजीकरण संख्या",
  rti_l_subject: "आपने क्या माँगा था (एक पंक्ति)",
  rti_l_reason: "अपील में देरी का कारण",
  rti_l_copy: "पत्र कॉपी करें",
  rti_l_print: "प्रिंट करें",
  rti_ph_name: "[आपका नाम]",
  rti_ph_addr: "[आपका पता]",
  rti_ph_auth: "[लोक प्राधिकरण का नाम और पता]",
  rti_ph_pio: "[PIO का नाम या पदनाम]",
  rti_ph_reg: "[पंजीकरण संख्या]",
  rti_ph_subject: "[माँगी गई सूचना]",
  rti_ph_reason: "[देरी का कारण]",
  rti_letter_body: "सेवा में\nप्रथम अपील प्राधिकारी\n{auth}\n\nप्रेषक\n{name}\n{addr}\n\nदिनांक: {today}\n\nविषय: सूचना का अधिकार अधिनियम, 2005 की धारा 19(1) के अंतर्गत प्रथम अपील\n\nमहोदय/महोदया,\n\n1. {filed} को {auth} के लोक सूचना अधिकारी ({pio}) को सूचना का अधिकार अधिनियम, 2005 की धारा 6 के अंतर्गत मेरा आवेदन प्राप्त हुआ (पंजीकरण संख्या {reg})। उसमें यह सूचना माँगी गई थी: {subject}।\n\n2. अधिनियम की धारा 7(1) के अनुसार {due} तक निर्णय दिया जाना था। मुझे कोई निर्णय प्राप्त नहीं हुआ है। धारा 7(2) के अनुसार यह माना जाएगा कि अनुरोध अस्वीकार कर दिया गया है।\n\n3. {timing}\n{record}\nअतः आपसे निवेदन है कि:\n(क) लोक सूचना अधिकारी को निर्देश दें कि माँगी गई सूचना धारा 7(6) के अंतर्गत निःशुल्क दी जाए, क्योंकि समय-सीमा का पालन नहीं हुआ;\n(ख) इस अपील का निर्णय धारा 19(6) में तय अवधि के भीतर करें।\n\nसंलग्न: RTI आवेदन की प्रति और उसकी डिलीवरी का प्रमाण।\n\nभवदीय,\n{name}",
  rti_letter_intime: "यह अपील धारा 19(1) में दिए गए तीस दिनों के भीतर की जा रही है।",
  rti_letter_late: "यह अपील धारा 19(1) में दिए गए तीस दिनों के बाद की जा रही है। निवेदन है कि उस धारा के परंतुक के अंतर्गत इसे स्वीकार किया जाए, क्योंकि {reason}।",
  rti_letter_record: "\n4. आवेदन का सॉल्ट मिला फ़िंगरप्रिंट Arkiv नेटवर्क पर ब्लॉक {block} में {time} को दर्ज किया गया। इससे पता चलता है कि आवेदन तब तक मौजूद था: {link}\nइस रिकॉर्ड को संलग्न आवेदन की प्रति से मिलाने वाली रसीद मेरे पास है।\n",
  vl_ignored: " · {m} नहीं गिने गए",
  vl_size: "{c} × 96 KiB एन्क्रिप्टेड डेटा · {d} को सील",
};
